import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { toggleMenu, listMenu } from '../../_actions'
import { useWindowSize } from '../../_helpers'
import {
    Image,
    devices,
    colors,
    UpperHeader,
    Button,
    LeftArrow,
} from '../Common'

export const Nav = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { menu, menuOpen } = useSelector(state => state.content)
    const { width } = useWindowSize()
    const mobile = width < 480

    const [activeMenu, setActiveMenu] = useState(menu)
    const [prevMenu, setPrevMenu] = useState(null)
    const [menuTitle, setMenuTitle] = useState('Menu')
    const [activeImage, setActiveImage] = useState(null)
    // const [prevTitle, setPrevTitle] = useState('')

    useEffect(() => {
        dispatch(listMenu())
        if (!menu) setActiveMenu(menu)
    }, [])

    const openMenuPanel = () => {
        dispatch(toggleMenu(!menuOpen))
        document.body.style.overflow = menuOpen ? 'visible' : 'hidden'
    }

    // close individual menuItem
    const changeLocation = location => e => {
        e.preventDefault()
        if (!location) return
        if (location !== history.location.pathname) {
            history.push(location)
        }
        closePanel()
    }

    // Hide the entire side menu
    const closePanel = () => {
        dispatch(toggleMenu(false))
        setActiveMenu(menu)
        setMenuTitle('Menu')
        setPrevMenu(null)
        document.body.style.overflow = 'visible'
    }

    const menuDown = (menuItem, parent) => {
        setMenuTitle(menuItem.title)
        setActiveMenu(menuItem.children)
        setPrevMenu(parent)
    }

    const menuUp = () => {
        setActiveMenu(prevMenu)
        console.warn(prevMenu)
        setMenuTitle(prevMenu === menu ? 'Menu' : prevMenu.title)
        if (prevMenu === menu) {
            setPrevMenu(null)
        }
    }

    return (
        <NavigationWrap>
            <div>
                <MenuButton role='button' open={menuOpen} onClick={openMenuPanel}>
                    <div>
                        <div />
                        <div />
                        <div />
                    </div>
                </MenuButton>
            </div>
            <Menu>
                <ButtonContainer>
                    <CloseButton role='button' aria-label='Close Menu' onClick={closePanel} />
                    {prevMenu && <BackButton onClick={menuUp}> <LeftArrow /> PREVIOUS SCREEN</BackButton>}
                </ButtonContainer>
                <MenuTitle marginbottom={30}>{menuTitle}</MenuTitle>
                {activeMenu.length ? activeMenu.map(item =>
                    <NavItemHeader
                        key={item.title}
                        as={item.children.length === 0 ? Link : ''}
                        to={item.children.length === 0 ? item.linked_page : ''}
                        onClick={item.children.length === 0 ? changeLocation(item.linked_page) : () => menuDown(item, activeMenu)}
                    >
                        {item.title}
                    </NavItemHeader>
                ) : menu.map(item =>
                    <NavItemHeader
                        key={item.title}
                        as={item.children.length === 0 ? Link : ''}
                        to={item.children.length === 0 ? item.linked_page : ''}
                        // onClick={item.children.length === 0 ? changeLocation(item.linked_page) : () => menuDown(item, activeMenu)}
                        onMouseEnter={() => item.first_image !== null ? setActiveImage(item.first_image) : ''}
                    >
                        {item.title}
                    </NavItemHeader>
                )}
            </Menu>
            {activeImage && <NavImage src={activeImage} />}
        </NavigationWrap>
    )
}

// const MobileControls = styled.div`
//     height: 65px;
//     position: relative;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
// `

// const MobileLogo = styled.div`
//     background: url('/static/images/sprite.svg') no-repeat -220px -210px;
//     width: 223px;
//     height: 30px;
// `

const NavImage = styled(Image)`
    width: 40%;
    height: 45%;
`

const ButtonContainer = styled.div`
    display: flex;
    margin-bottom: 30px;
`

const BackButton = styled(Button)`
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 10px 15px 9px;
`

const CloseButton = styled.div`
    width: 40px;
    height: 40px;
    background: url('/static/images/sprite.svg') no-repeat  -79px -78px;
    border: 1px solid ${colors.white};
    border-radius: 50%;
    /* padding: 10px; */
    margin-right: 10px;
    cursor: pointer;
`

const NavItem = styled.div`
    position: relative;
    /* margin-bottom: 20px; */
    display: flex;
    flex-direction: column;
    @media ${devices.small} {
        margin-bottom: 0;
        padding-bottom: 20px;
    }
`

const NavigationWrap = styled.nav`
    display: flex;
    flex-direction: row;
    /* justify-content: space-between; */
    background: ${colors.red};
    height: 100vh;
    width: calc(50vw + 50px);
    /* cursor: pointer; */
    position: fixed;
    left: 0;
    flex: 1;
    z-index: 0;
    padding: 4vh 2vw;
    background: ${colors.pink};
    color: ${colors.white};

    @media ${devices.small} {
    }
`

const Menu = styled.div`
    /* max-height: 100vh; */
    padding: 0 40px;
    overflow-x: hidden;

    ${NavItem} {
        width: 100%;
    }

    @media (max-width: 1450px) {
        /* padding-left: 0;
        padding-right: 0; */
    }

    @media ${devices.small} {
        padding: 30px 0 0 0;
        margin-bottom: auto;
    }
`

const NavItemHeader = styled.div`
    font-size: 26px;
    cursor: pointer;
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    text-decoration: none;
    color: ${colors.white};
    margin-bottom: 10px;

    &:after {
        content: '';
        display: block;
        background: url('/static/images/sprite.svg') no-repeat -85px -55px;
	    width: 23px;
	    height: 20px;
        margin-left: 20px;
        opacity: 0;
        transition: all 0.2s ease-in;
    }

    &:hover {
        &:after {
            opacity: 1;
        }
    }

    @media ${devices.small} {
        font-size: 45px;
        padding-left: 0;
        margin-bottom: 0;
        padding-bottom: 20px;
    }
`

const MenuButton = styled.div`
    display: flex;
    height: 32px;
    padding: 1px 0 0;
    cursor: pointer;
    // font-family: '';
    font-size: 38px;
    line-height: 1;
    color: ${colors.white};
    ${({ small }) => small ? 'margin-top: -17px;' : ''}

    > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 35px;
        height: 35px;

        > div {
            height: 3px;
            margin: 3px 0;
            background: ${colors.white};
        }
    }

    @media ${devices.small} {
        height: 21px;

        > div {
            height: 21px;
        }
    }
`

const MenuTitle = styled(UpperHeader)`
`